(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rj-home-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-rj-reviews]').forEach(section => {
    if (section.dataset.rjLoaded || !section.dataset.publicKey || !section.dataset.store) return;
    section.dataset.rjLoaded = 'true';
    const load = async () => {
      const target = section.querySelector('[data-rj-summary]');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const url = new URL('https://stamped.io/api/widget/reviews');
        url.search = new URLSearchParams({type: 'site-badge', apiKey: section.dataset.publicKey, storeUrl: section.dataset.store});
        const response = await fetch(url, {signal: controller.signal, credentials: 'omit'});
        if (!response.ok) return;
        const data = await response.json();
        const rating = Number(data.ratingAll), count = Number(data.totalAll);
        if (!Number.isFinite(rating) || rating <= 0 || rating > 5 || !Number.isInteger(count) || count <= 0) return;
        const locale = document.documentElement.lang || 'sv';
        const formatted = new Intl.NumberFormat(locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rating);
        target.textContent = formatted + ' / 5 ' + section.dataset.summaryLabel.replace('{count}', new Intl.NumberFormat(locale).format(count));
        target.hidden = false;
      } catch (_) {
        target.hidden = true;
      } finally {
        clearTimeout(timeout);
      }
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
      }, {rootMargin: '300px'});
      observer.observe(section);
    } else load();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
